{
	"createParentColumns": [
		{
			"display": "true",
			"ui_columnname": "groupName",
			"db_columnname": "groupName",
			"datatype": "String",
			"mappingkey": "groupName",
			"dropdown": "Yes",
			"disabled": false,
			"isrequired": true,
			"value": "",
			"dropdownvalue": "",
			"dropdowntype": "singleselect"
		},
		{
			"display": "true",
			"ui_columnname": "deptType",
			"db_columnname": "deptType",
			"datatype": "String",
			"mappingkey": "deptType",
			"dropdown": "Yes",
			"disabled": false,
			"isrequired": true,
			"value": "A",
			"dropdownvalue": "",
			"dropdowntype": "singleselect"
		},
		{
			"display": "true",
			"ui_columnname": "accountHolderType",
			"db_columnname": "accountHolderType",
			"datatype": "String",
			"mappingkey": "accountHolderType",
			"dropdown": "Yes",
			"disabled": false,
			"isrequired": true,
			"value": "A",
			"dropdownvalue": "",
			"dropdowntype": "singleselect"
		},
		{
			"display": "true",
			"ui_columnname": "tradingSession",
			"db_columnname": "tradingSession",
			"datatype": "String",
			"mappingkey": "tradingSession",
			"dropdown": "Yes",
			"disabled": false,
			"isrequired": true,
			"value": "ALL",
			"dropdownvalue": "",
			"dropdowntype": "singleselect"
		},
		{
			"display": "true",
			"ui_columnname": "firmDesignatedID",
			"db_columnname": "firmDesignatedID",
			"datatype": "String",
			"mappingkey": "firmDesignatedID",
			"dropdown": "NO",
			"disabled": false,
			"isrequired": true,
			"value": "",
			"dropdownvalue": "",
			"maxlength": "40"
		}
	]
}